// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-data-table[data-v-5a187d1b]  .v-data-table-header{background-color:#f5f6f8!important;text-transform:uppercase!important}", ""]);
// Exports
module.exports = exports;
